<rt-dropdown [width]="DropdownWidth.FullWidth">
  <rt-group variant="horizontal">
    <rt-icon-button
      [pressed]="getActive() === 'left'"
      [rtTooltip]="'wysiwyg.left' | translate"
      (click)="select('left')"
      variant="plain"
      size="small"
      iconName="format-align-left"
    ></rt-icon-button>
    <rt-icon-button
      [pressed]="getActive() === 'center'"
      [rtTooltip]="'wysiwyg.center' | translate"
      (click)="select('center')"
      variant="plain"
      size="small"
      iconName="format-align-center"
    ></rt-icon-button>
    <rt-icon-button
      [pressed]="getActive() === 'right'"
      (click)="select('right')"
      [rtTooltip]="'wysiwyg.right' | translate"
      variant="plain"
      size="small"
      iconName="format-align-right"
    ></rt-icon-button>
  </rt-group>
</rt-dropdown>
